exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.disabled{width:100%;height:100%;background:black;opacity:0.8;position:absolute;left:0;top:0;color:#b7b0a9\n}\n.disabled div{text-align:center;padding-top:14px;font-weight:bold\n}\n.subcontent{position:relative\n}\n", ""]);

// exports
